export type OutreachComposeOpenParams = {
  accountId?: string | null;
  accountName?: string | null;
  dealId?: string | null;
  dealName?: string | null;
  roomId?: string | null;
  recipientId?: string | null;
  context?: string;
};

export function outreachComposeParamsKey(params: OutreachComposeOpenParams | null): string {
  if (!params) return 'closed';
  return JSON.stringify({
    accountId: params.accountId ?? null,
    dealId: params.dealId ?? null,
    roomId: params.roomId ?? null,
    recipientId: params.recipientId ?? null,
    context: params.context ?? '',
  });
}
